import React from 'react';
import { Box, Typography } from '@mui/material';

const CustomerInfoDisplay = ({ customer, customerInfoGridSx, customerInfoFieldSx, customerInfoLabelSx, customerInfoValueSx }: any) => (
  <Box sx={customerInfoGridSx}>
    <Box sx={customerInfoFieldSx}>
      <Typography sx={customerInfoLabelSx}>Customer ID</Typography>
      <Typography sx={customerInfoValueSx}>{customer.id}</Typography>
    </Box>
    <Box sx={customerInfoFieldSx}>
      <Typography sx={customerInfoLabelSx}>Name</Typography>
      <Typography sx={customerInfoValueSx}>{customer.name}</Typography>
    </Box>
    <Box sx={customerInfoFieldSx}>
      <Typography sx={customerInfoLabelSx}>Mobile</Typography>
      <Typography sx={customerInfoValueSx}>{customer.mobileNumber}</Typography>
    </Box>
    <Box sx={customerInfoFieldSx}>
      <Typography sx={customerInfoLabelSx}>Email</Typography>
      <Typography sx={customerInfoValueSx}>{customer.email || 'N/A'}</Typography>
    </Box>
    <Box sx={customerInfoFieldSx}>
      <Typography sx={customerInfoLabelSx}>Gender</Typography>
      <Typography sx={customerInfoValueSx}>{customer.gender || 'N/A'}</Typography>
    </Box>
    <Box sx={customerInfoFieldSx}>
      <Typography sx={customerInfoLabelSx}>Address</Typography>
      <Typography sx={customerInfoValueSx}>{customer.address || 'N/A'}</Typography>
    </Box>
  </Box>
);

export default CustomerInfoDisplay;